<!--<div id="bg" (window:resize)="onResize()">-->
<div id="bg">
  <router-outlet></router-outlet>
  <div class="footer">
    <img *ngIf="ShowLogo()" class="salesdash-logo" src="https://planted-assets.s3.us-east-2.amazonaws.com/white_wordmark_color_1000px.png">
  </div>
  <p-toast></p-toast>
</div>

